import { toTypedRxJsonSchema } from 'rxdb';
import type { ExtractDocumentTypeFromTypedRxJsonSchema, RxJsonSchema } from 'rxdb';

const tagSchemaLiteral = {
  title: 'tag schema',
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      maxLength: 128, // id is in format <userid>-<tagname>
      type: 'string',
    },
    userId: { type: 'string' },

    name: { type: 'string' },
    numDocs: { type: 'number' },
    color: { type: 'string' },

    // no aliases, tags

    createdAt: { type: 'string' },
    updatedAt: { type: 'string' },
  },
  required: ['id', 'userId', 'name', 'numDocs', 'color', 'createdAt', 'updatedAt'],
} as const;
const _tagSchemaTyped = toTypedRxJsonSchema(tagSchemaLiteral);

export type Tag = ExtractDocumentTypeFromTypedRxJsonSchema<typeof _tagSchemaTyped>;
export const tagSchema: RxJsonSchema<Tag> = tagSchemaLiteral;
